// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 978 ? "vendor.howler" : chunkId) + "." + {"893":"4766bce7","978":"a8011ae7"}[chunkId] + ".chunk.js";
};